import PessoaGenero from "@/Models/Pessoa/PessoaGenero";
import { Axios } from "@/Services/Axios";
import RequestUtilitario, { QueryBasicaParam } from "@/Utils/RequisicaoUtilitario";
import { useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

export function usePessoaGeneroListar({
    pessoaGenero,
    ativo,
    ...rest
}:QueryBasicaParam<AxiosResponse<PessoaGenero[]>, PessoaGenero[], {
    pessoaGenero?:PessoaGenero,
    ativo?:boolean
}>) {
    const queryString = RequestUtilitario.objectToQueryString({
        ...(pessoaGenero ?? {}),
        ativo
    });

    return useQuery({
        ...rest,
        queryKey : [ "Pessoa.PessoaGenero.ListarTodos", `Pessoa.PessoaGenero.ListarTodos?${queryString}` ],
        queryFn : () => Axios.get<PessoaGenero[]>(`pessoa/PessoaGenero?${queryString}`),
        staleTime : 1000 * 60 * 2.5,
        select(data) {
            return data.data;
        },
    });
}